<ion-app>
  <ion-router-outlet></ion-router-outlet>

  <!-- Fullscreen spinner -->
  <custom-spinner *ngIf="isLoading$ | async"></custom-spinner>
</ion-app>
